const MAX_RECENT_SEARCHES = 6;

const storageKey = (userId: string): string =>
	`finishd:inspire-recent-searches:${userId}`;

/**
 * A user's recent Inspire searches, newest first. Storage can be missing,
 * blocked or hold something else, and none of that may break the page, so
 * every access is guarded and an unreadable value reads as no history.
 */
export function readRecentSearches(userId: string): string[] {
	try {
		const raw = window.localStorage.getItem(storageKey(userId));
		if (!raw) return [];
		const parsed: unknown = JSON.parse(raw);
		if (!Array.isArray(parsed)) return [];
		return parsed
			.filter((entry): entry is string => typeof entry === "string")
			.slice(0, MAX_RECENT_SEARCHES);
	} catch {
		return [];
	}
}

/**
 * Puts `query` first in the user's history, dropping an earlier copy that
 * differs only in case, and returns the history as it now stands.
 */
export function addRecentSearch(userId: string, query: string): string[] {
	const term = query.trim();
	const current = readRecentSearches(userId);
	if (!term) return current;
	const next = [
		term,
		...current.filter((entry) => entry.toLowerCase() !== term.toLowerCase()),
	].slice(0, MAX_RECENT_SEARCHES);
	try {
		window.localStorage.setItem(storageKey(userId), JSON.stringify(next));
	} catch {
		// Storage is full or blocked: the history lasts for this visit only.
	}
	return next;
}
